import React from "react";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { experiences } from "../../data";

function TimelineItem({ exp, index }) {
  const ref = useScrollReveal();
  return (
    <div
      ref={ref}
      className={`timeline-item reveal${exp.current ? " current" : ""}`}
      style={{ transitionDelay: `${index * 0.08}s` }}
    >
      <div className="timeline-dot">
        <div className="timeline-dot-inner" />
      </div>

      <div className="timeline-content">
        <div className="timeline-header">
          <div>
            <div className="timeline-role">
              {exp.role}
              {exp.current && <span className="timeline-badge">Current</span>}
            </div>
            <div className="timeline-company">{exp.company}</div>
          </div>
          <div className="timeline-meta">
            <span className="timeline-period">{exp.period}</span>
            {exp.note && <div className="timeline-note">{exp.note}</div>}
          </div>
        </div>

        <ul className="timeline-points">
          {exp.points.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>

        {exp.keyProjects && exp.keyProjects.length > 0 && (
          <div className="timeline-key-projects">
            <div className="timeline-project-label">Key Projects</div>
            {exp.keyProjects.map((project, i) => (
              <span key={i} className="timeline-project-item">{project}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function Experience() {
  const headerRef = useScrollReveal();

  return (
    <section id="experience" className="section experience-section">
      <div className="section-inner">
        <div ref={headerRef} className="reveal" style={{ marginBottom: "56px" }}>
          <p className="section-label">Career</p>
          <h2 className="section-title">
            Work <span>Experience</span>
          </h2>
          <p className="section-subtitle">
            5+ years of building production systems across diverse industries — from logistics and fintech to food-tech and enterprise HR.
          </p>
        </div>

        <div className="timeline">
          {experiences.map((exp, i) => (
            <TimelineItem key={exp.id} exp={exp} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
